import type { FC } from "react";
import responsiveColumn from "../../../methods/responsiveColumn";
import { Button, Card, Col, Grid } from "antd";
import { useTranslation } from "next-i18next";
import styles from "./practiceStyle.module.sass";
import UnOrderedListComp from "./UnOrderedListComp";
import type { PractiseAreaProps } from "./PracticeAreasSection";
import Link from "next/link";

interface BoxComponentProps {
  id: number;
  title: string;
  description: string;
  href: string;
  learn_more: string;
  list: string;
  isOpen: boolean;
  toggleDropdown: (openCardProps: PractiseAreaProps) => void;
  openCard: PractiseAreaProps | null;
}

export const BoxComponent: FC<BoxComponentProps> = ({
  id,
  title,
  description,
  href,
  learn_more,
  list,
  isOpen,
  toggleDropdown,
  openCard,
}) => {
  const { t } = useTranslation("practice_groups_home");
  const { useBreakpoint } = Grid;
  const screenSize = useBreakpoint();

  return (
    <>
      <Col {...responsiveColumn([8,12, 12, 12, 24, 24, 24])}>
        <Card
          size='small'
          style={{
            boxShadow: "-9px 9px 15px rgb(0 0 0 / 60%)",
            paddingLeft: 15,
            paddingRight: 15,
            paddingTop: 15,
          }}
        >
          <Card.Meta
            title={<span style={{ fontSize: 24 }}>{title}</span>}
            style={{ minHeight: 120 }}
            description={<span style={{ fontSize: 16 }}>{description}</span>}
          />

          <Link href={href}
            style={{
              float: "left",
              border: "none",
              background: "none",
              padding: 0,
              marginTop: 35,
            }}
            // onClick={() =>
            //   toggleDropdown({ id, title, description, href, learn_more, list })
            // }
            // key={id}
          >
            <span
              style={{
                float: "left",
                color: "#254486",
                textDecoration: "underline",
                fontSize: 16,
              }}
            >
              {t("home_section9.section3_learn_more")}
            </span>
          </Link>
        </Card>
        {isOpen && !screenSize.lg && (
          <div className={styles.headerDropDown}>
            <UnOrderedListComp openCard={openCard} />
          </div>
        )}
      </Col>
      {id % 2 != 0 && screenSize.lg && (
        <Col
          className={
            typeof openCard?.id === "number" &&
            (openCard.id === id || id === openCard.id + 1)
              ? styles.block
              : styles.hidden
          }
        >
          <div
            className={
              typeof openCard?.id === "number" && openCard.id % 2 !== 0
                ? styles.rightHeaderDropDown
                : styles.headerDropDown
            }
          >
            <UnOrderedListComp openCard={openCard} />
          </div>
        </Col>
      )}
    </>
  );
};
